import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import IconArrowRight from 'assets/images/icon-arrow-right.svg';

import { Spinner } from 'components/Common';

import BoxLinkContainer from './BoxLinkContainer';

class BoxLink extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.node,
    meta: PropTypes.string,
    small: PropTypes.bool,
    inactive: PropTypes.bool,
    icon: PropTypes.string,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    image: null,
    description: null,
    meta: null,
    small: false,
    inactive: false,
    icon: IconArrowRight,
    isLoading: false,
    onClick: null
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick();
      event.preventDefault();
    }
  };

  render() {
    const classList = ['boxlink'];

    if (this.props.small) {
      classList.push('boxlink--small');
    }

    if (this.props.inactive) {
      classList.push('boxlink--inactive');
    }

    return (
      <Link
        className={classList.join(' ')}
        to={this.props.to}
        onClick={this.handleClick}
      >
        {this.props.image && (
          <div className="boxlink__media">
            <img className="boxlink__image" src={this.props.image} alt="" />
          </div>
        )}

        <div className="boxlink__content">
          <h3 className="boxlink__title">{this.props.title}</h3>

          {this.props.description && (
            <p className="boxlink__description">{this.props.description}</p>
          )}

          {this.props.meta && (
            <p className="boxlink__meta">{this.props.meta}</p>
          )}
        </div>

        {this.props.isLoading ? (
          <div className="boxlink__spinner">
            <Spinner />
          </div>
        ) : (
          <img className="boxlink__arrow" alt="" src={this.props.icon} />
        )}
      </Link>
    );
  }
}

BoxLink.Container = BoxLinkContainer;

export default BoxLink;



// WEBPACK FOOTER //
// ./src/components/Common/BoxLink/BoxLink.js